import { useSelector } from "react-redux";
import { useState } from "react";
import { TokenEntity } from "../../../../../entities/ServicesEntities/UserEntities/TokenEntity";
import {
  ASSIGN_OPTIONS,
  INPUTS_PROPS
} from "../../../../../enums/Enums";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import store from "../../../../../redux/Store";
import Strings from "../../../../../resources/Strings";
import AssigneFobToggleButtons from "../../../Buttons/CustomToggleButton/AssigneFobButtons/AssigneFobToggleButtons";
import ExistingAllocationInputWithoutVerification from "../../../Inputs/ScanWithFobsInputs/ExistingAllocationInputWithoutVerification";
import ScanFobInput from "../../../Inputs/ScanWithFobsInputs/ScanFobInput";
import classes from "../WizardForm.module.css";
import * as actionsService from "../../../../../services/ActionsService/ActionsService";

const AddSingleTokenParkerAllocation = (props) => {
    const showScanFobButton = useSelector((state) => state.common.showScanFobButton);
    const showFobScannerInput = useSelector((state) => state.common.showFobScannerInput);
    const showAssigneFobOptions = useSelector((state) => state.common.showAssigneFobOptions);
    const assigneOption = useSelector((state) => state.common.assigneOption);
    const showExsistingParkingAllocation = useSelector((state) => state.common.showExsistingParkingAllocation);
    const [hasLocalErrors, setHasLocalErrors] = useState(false);
    const [skipFob, setSkipFob] = useState(false);
    
    const handleConfirmScanFob = () => {
    props.handleChange({ ["isStepSubmitted"]: true });
    setSkipFob(false);
    //let isSameValueFobFounded = props.assignedParkers?.some(parker => parker.carUserTokens?.fob === props.fob)
    let isSameValueFobFounded = props.assignedParkerAllocations?.some(cut => cut?.fob === props.fob);
    if (props.fob === null || props.fob === "") {
      // error
      //props.handleChange({ ["isStepSubmitted"]: true });
      props.setShowStepError(true);
      setHasLocalErrors(false);
      /*
      setShowAssigneFobOptions(false);
      setShowFobScannerInput(true);
      */
      // reducer
      store.dispatch(commonActions.setShowAssigneFobOptions(false));
      store.dispatch(commonActions.setShowFobScannerInput(true));
    }
    else {
      // removes 'step is required' error
      props.setShowStepError(false); 
      // before doin the server validation check
      // check if attempting to use the same fob value for a new assigned parker
      // if same value fob founded - show already assigned fob
      if (isSameValueFobFounded) {
        setHasLocalErrors(true);
        store.dispatch(commonActions.setShowAssigneFobOptions(false));
        store.dispatch(commonActions.setShowFobScannerInput(true));
      }
      else {
        actionsService.isFobOk(props.fob).then(response => {
          //props.setShowStepError(false);
          if(response?.data?.isSuccess){
            setHasLocalErrors(false);
            /*
            setShowAssigneFobOptions(true);
            setShowFobScannerInput(false);
            */
            props.handleChange({['showTemporaryTokenPreview'] : true});
            // dont show again assigns options if there is already atleast one assigned parker
            // will show the options only on the first time when there is no assigned parker yet
            store.dispatch(commonActions.setShowAssigneFobOptions(true));

            //store.dispatch(commonActions.setShowAssigneFobOptions(true)); // prev code
            store.dispatch(commonActions.setShowFobScannerInput(false));
          }else{
            setHasLocalErrors(true);
            store.dispatch(commonActions.setShowAssigneFobOptions(false));
            store.dispatch(commonActions.setShowFobScannerInput(true));
          }
        }).catch(err => console.log(err));
      }
    }
  };

  const handleAssigneOptionChange = (event, selectedValue) => {
    let isReset = false;
    // reducer
    store.dispatch(commonActions.setAssigneOption(selectedValue));

    // if null clear carTokens
    if (!selectedValue || selectedValue === null) {
      handleChange({ [INPUTS_PROPS.CAR_USER_TOKEN]: [] });
      props.handleClearAllTokens();
      isReset = true;
    }

    // prev: props.fob // !props.isFobSkipped
    // new && fob supported
    if (selectedValue == ASSIGN_OPTIONS.NEW) {
      //new parking allocation
      props.handleAssignTokenToFob(
        new TokenEntity(
          0,
          props.selectedSite.isOutSourceGarage ? props.fob : null, // null, //props.fob === '' ? null : props.fob, // addeed (before : null)
          `Parking Allocation - ${props.fob} (New)`,
          //props.site,
          props.selectedSite?.id,
          props.userType,
          props.isPaying,
          false
        ),
        skipFob
      );
      /*
      setShowAssigneFobOptions(false);
      setShowScanFobButton(true);
      */

      // reducer
      store.dispatch(commonActions.setShowAssigneFobOptions(false));
      store.dispatch(commonActions.setShowScanFobButton(false));

      // allocation add
      store.dispatch(commonActions.setShowAdditionalParkingAllocationButton(true));

      if (props.fromGmt === undefined) {
        props.setIsShowSaveChanges(true)
      }
      
    } // Exist && fob supported
    else if (selectedValue == ASSIGN_OPTIONS.EXSIST && props.fob) {
      //Exsiting parking allocation
      store.dispatch(commonActions.setShowExsistingParkingAllocation(true));
      store.dispatch(commonActions.setShowAssigneFobOptions(false));

      if (props.fromGmt === undefined) {
        //props.setIsShowSaveChanges(props.occupiedTokens?.length > 0 ? true : false);
        props.setIsShowSaveChanges(false);
      }

    } // Exist
    else if (selectedValue == ASSIGN_OPTIONS.EXSIST) { // added

      store.dispatch(commonActions.setShowExsistingParkingAllocation(true));
      store.dispatch(commonActions.setShowAssigneFobOptions(false));
      
    } // New && fob not supported 
    else if (selectedValue == ASSIGN_OPTIONS.NEW && props.isFobSkipped) { // && props.isFobSkipped
      if (props.carUserTokens.length === 0 && !isReset) { // props.carUserTokens.length === 0
        props.handleAssignTokenToFob(
          new TokenEntity(
            0,
            null, // props.fob === '' ? null : props.fob,
            `Parking Allocation - (New)`,
            //props.site,
            props.selectedSite?.id,
            props.userType,
            props.isPaying,
            false
          )
        );

        store.dispatch(commonActions.setShowAssigneFobOptions(false));

        // dont show again assigns options if there is already atleast one assigned parker
        // will show the options only on the first time when there is no assigned parker yet
        // --this section will occur only one time
        if (props.assignedParkerAllocations?.length !== 0) {
           // allocation add
           //store.dispatch(commonActions.setShowAddNewUserButton(true));
           store.dispatch(commonActions.setShowAdditionalParkingAllocationButton(true));
           store.dispatch(commonActions.setShowAssigneFobOptions(false));
           store.dispatch(commonActions.setShowScanFobButton(false));
           //props.handleAssignTokenToFob(null);
           //props.handleChange({ ["selectedParker"]: null, ["fob"] : null });
        }

        // allocation add
        //store.dispatch(commonActions.setShowAddNewUserButton(true));
        store.dispatch(commonActions.setShowAdditionalParkingAllocationButton(true));
        //props.handleChange({["selectedParker"] : null});
        
        if (props.fromGmt === undefined) {
          props.setIsShowSaveChanges(true);
        }
      }
    }
  };

  const handleChange = (event) => {
    props.handleChange(event);
  };

  const handleClose = () => {
    /*
    setShowScanFobButton(true);
    setShowFobScannerInput(false);
    setAssigneOption(null);
    */

    // reducer
    store.dispatch(commonActions.setShowScanFobButton(true));
    store.dispatch(commonActions.setShowFobScannerInput(false));
    store.dispatch(commonActions.setShowAdditionalParkingAllocationButton(true));
    store.dispatch(commonActions.setAssigneOption(null));

    if (props.fromGmt === undefined) {
      props.setIsAddParkingAllocationInProcess(false); // added
      //props.setIsShowSaveChanges(false);

      // show save changes if there is any allocations that previously added
      if (props?.carUserTokens?.length > 0) {
        props.setIsShowSaveChanges(true);
      }
    }

    handleChange({
      ["isStepSubmitted"]: false,
      ["selectedParker"] : null,
      [INPUTS_PROPS.FOB]: "",
    });
  }

  const handleDeleteFob = () => {
    store.dispatch(commonActions.setShowScanFobButton(true));
    store.dispatch(commonActions.setShowAssigneFobOptions(false));
    store.dispatch(commonActions.setShowFobScannerInput(false));
    store.dispatch(commonActions.setShowExsistingParkingAllocation(false));
    store.dispatch(commonActions.setAssigneOption(null));
    store.dispatch(commonActions.setShowAdditionalParkingAllocationButton(true));

    if (props.fromGmt === undefined) {
      //props.setIsShowSaveChanges(false);

      // show save changes if there is any allocations that previously added
      if (props?.carUserTokens?.length > 0) {
        props.setIsShowSaveChanges(true);
      }

      props.setIsAddParkingAllocationInProcess(false); // added
    }

    props.handleChange({
      ["selectedParker"] : null,
      ["fob"] : "",
      ["showTemporaryTokenPreview"] : false
    });

    //handleChange({ [INPUTS_PROPS.FOB]: "" });
  };

  const handleAssignTokenToFob = (token) => {
    /*
    setShowScanFobButton(true);
    setAssigneOption(null);
    */

    store.dispatch(commonActions.setShowScanFobButton(false));
    store.dispatch(commonActions.setShowExsistingParkingAllocation(false));
    store.dispatch(commonActions.setAssigneOption(null));

    props.handleAssignTokenToFob({ ...token?.token, displayValue: `Parking Allocation, (Occupied: ${token?.token.displayValue})` });
    if (props.fromGmt === undefined) {
      props.setIsShowSaveChanges(true)
    }
  };

  const handleSkip = () => {
    // setIsFobSkipped(true);  - prev
    // props.setIsFobSkipped(true);
    /*
    setShowScanFobButton(false);
    setShowFobScannerInput(false);
    setShowAssigneFobOptions(true);
    */
    setSkipFob(true);
    // reducer
    store.dispatch(commonActions.setShowScanFobButton(false));
    store.dispatch(commonActions.setShowFobScannerInput(false));
    store.dispatch(commonActions.setShowAssigneFobOptions(true));

    props.setShowStepError(false);

    handleChange({ [INPUTS_PROPS.FOB]: "" }); // "", null
  };

//   const scanNewFob = () => {
//     /*
//     setShowFobScannerInput(true);
//     setShowScanFobButton(false);
//     setShowAssigneFobOptions(false);
//     setShowExsistingParkingAllocation(false);
//     */

//     // with reducer
//     store.dispatch(commonActions.setShowFobScannerInput(true));
//     store.dispatch(commonActions.setShowScanFobButton(false));
//     store.dispatch(commonActions.setShowAssigneFobOptions(false));
//     store.dispatch(commonActions.setAssigneOption(null)); // added
//     store.dispatch(commonActions.setShowExsistingParkingAllocation(false));

//     if (props.fromGmt === undefined) {
//       props.setIsAddParkingAllocationInProcess(false);
//     }
//   };

    return (
    <div className={classes.stepContainer}>
      {/* {showScanFobButton && (
        <button
          onClick={scanNewFob}
          type="button"
          className={classes.addCarButton}
        >
          <img src={Icons.ADD_BUTTON} />
          <span>{Strings.SCAN_NEW_FOB_BUTTON}</span>
        </button>
      )} */}
      {/* {((!showScanFobButton && assigneOption === ASSIGN_OPTIONS.EXSIST) || showAssigneFobOptions || assigneOption === ASSIGN_OPTIONS.EXSIST) && (
          <div className={classes.switchToolTip}>
          <SwitchInput
            checked={props.isPaying}
            onChange={handleChange}
            leftText={"Non-Paying"}
            rightText={"Paying"}
            id={INPUTS_PROPS.IS_PAYING}
          />
          <CustomTooltip {...props}  tooltipTitle={Strings.TOOLTIP_INFO_TITLE.IS_PAYING} tooltipText={Strings.TOOLTIP_INFO_TEXT.IS_PAYING} />
        </div>
      )} */}
      {/* Scan Fob Input */}
      {showFobScannerInput && (
        <ScanFobInput
          label={Strings.INPUT_LABELS.FOB_SCAN}
          id={INPUTS_PROPS.FOB}
          value={props.fob}
          onChange={handleChange}
          handleClose={handleClose}
          handleSkip={handleSkip}
          isStepSubmitted={props.isStepSubmitted}
          handleConfirmScanFob={handleConfirmScanFob}
          handleError={false}
          //hasError={false}
          //errorMessage=""
          hasError={hasLocalErrors}
          errorMessage={hasLocalErrors ? Strings.INPUT_ERROR_MESSAGES.FOB_ALREADY_EXISTS : ""}
        />
      )}
      {/* Select New/Exsisting Parker */}
      {showAssigneFobOptions && (
        <div>
          <div className={classes.assignOptionsContainer}>
            <AssigneFobToggleButtons
              selectedOption={assigneOption}
              handleChange={handleAssigneOptionChange}
              handleDeleteFob={handleDeleteFob}
              fobId={props.fob}
              //isFobSkipped={isFobSkipped} // added
              isFobSkipped={props.isFobSkipped}
              skipFob={skipFob}
            />
          </div>
        </div>
      )}
      {/* Select From Exsisting Parker */}
      {showExsistingParkingAllocation && (
        <ExistingAllocationInputWithoutVerification
            handleChange={props.handleChange}
            handleDeleteFob={handleDeleteFob}
            fobId={props.fob}
            siteId={props?.selectedSite?.id}
            isPaying={props?.isPaying}
            handleAssignTokenToFob={handleAssignTokenToFob}
            userTypeId={props.userTypeId}
            isFobSkipped={props.isFobSkipped}
            skipFob={skipFob}
            dialingCode={props.dialingCode}
            phoneNumber={props.phoneNumber}
            occupiedTokens={props.occupiedTokens}
            isAddAllocationProcess={props.isAddAllocationProcess}
            userData={props?.userData}
            filterBy={props?.assignedParkerAllocations}
        />
      )}
    </div>
  );
};

export default AddSingleTokenParkerAllocation;